// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","hero":"Layout_hero__70VQQ"};